import { useCallback } from 'react';
import { useDecodedToken } from './authorization.hook';
import { useIsAuthenticated } from './user-info.hooks';

/** Returns `true` if User has permision for a particular feature.
 */

type Feature = 'Everest' | 'CMP' | 'TS_UNITE';

export function useIsFeatureWhitelisted() {
  const isAuthenticated = useIsAuthenticated();
  const decodedToken = useDecodedToken();

  return useCallback(
    (feature: Feature | Feature[]) => {
      if (isAuthenticated && decodedToken?.whiteListedFeatures) {
        if (typeof feature === 'string')
          return decodedToken.whiteListedFeatures.includes(feature);
        else
          return feature.some((f) =>
            decodedToken.whiteListedFeatures.includes(f.toString())
          );
      }
      return false;
    },
    [decodedToken, isAuthenticated]
  );
}
